// Post-Rollout PR 4 (PROB-28) — compact multi-select filter chips shared by
// the item-level Outstanding + Documents tabs. Empty selection means "all".

export function PillToggle<T extends string>({
  options,
  selected,
  onToggle,
  testIdPrefix,
}: {
  options: Array<{ value: T; label: string }>;
  selected: Set<T>;
  onToggle: (value: T) => void;
  testIdPrefix: string;
}) {
  return (
    <div className="flex flex-wrap gap-space-1">
      {options.map((o) => {
        const on = selected.has(o.value);
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onToggle(o.value)}
            aria-pressed={on}
            data-testid={`${testIdPrefix}-${o.value}`}
            className={`px-space-2 py-[2px] rounded-pill border text-caption font-medium ${
              on
                ? "bg-onyx text-white-pure border-onyx"
                : "bg-white-pure text-gray-mid border-border-light hover:border-gray-mid"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
